import { useEffect } from 'react';
import { Card } from 'antd';
import { observer } from 'mobx-react-lite';

type ReportViewProps = {
  reportTemplate?: Blob;
};

export const ReportView = observer(({ reportTemplate }: ReportViewProps) => {
  useEffect(() => {
    if (!reportTemplate) return;

    window.Stimulsoft.Base.StiLicense.loadFromFile('/reports/license.key');

    window.Stimulsoft.StiOptions.WebServer.encryptData = false;

    window.Stimulsoft.StiOptions.WebServer.url = '/ws/api/report_db_handler';

    const report = new window.Stimulsoft.Report.StiReport();

    const url = URL.createObjectURL(reportTemplate);

    report.loadFile(url);

    const viewer = new window.Stimulsoft.Viewer.StiViewer(
      undefined,
      'StiViewer',
      false,
    );

    viewer.report = report;

    viewer.renderHtml('report-view-container');

    return () => {
      URL.revokeObjectURL(url);
      viewer.dispose();
    };
  }, [reportTemplate]);

  return (
    <Card size="small">
      <div id="report-view-container" style={{ minHeight: 100 }}></div>
    </Card>
  );
});
